import React from "react";
import { BsShop } from "react-icons/bs";
import SellingCategories from "../../Data/SellerInterviewData";
import CategoriesForSeller from "../Box/CategoriesForSeller";

const SellerInterview = ({ onNext }) => {
  return (
    <div className="w-full md:px-5 px-2 py-5 flex md:flex-row flex-col">
      <div className="md:basis-2/12 md:block hidden ">
        <BsShop className="text-7xl mx-auto" />
      </div>

      <div className="md:basis-6/12 w-full border border-transparent border-r-gray-300 ">
        <h1 className="text-amber-500 text-lg font-medium mb-2">
          Choose categories you wish to sell{" "}
        </h1>
        <h1 className="text-gray-400 text-xs font-medium mb-2">
          Choose categories you wish to sell
        </h1>
        <div className="w-full grid md:grid-cols-3 grid-cols-1 gap-1 pb-2 border border-transparent border-b-gray-300">
          {SellingCategories.map((curElem, index) => {
            return (
              <CategoriesForSeller
                index={index}
                heading={curElem.heading}
                products={curElem.products}
              />
            );
          })}
        </div>
        <div className="py-2 mb-2 border border-transparent border-b-gray-300">
          <h1 className="text-xs font-semibold text-gray-800 mb-2">
            Where do you get Products from
          </h1>
          <div className="flex items-center my-2">
            <input id="manufacture-himself" type="checkbox" className="block" />
            <label
              for="manufacture-himself"
              className="ml-2 text-gray-800 block text-xs"
            >
              I manufacture them
            </label>
          </div>
          <div className="flex items-center my-2">
            <input id="resell" type="checkbox" className="block" />
            <label for="resell" className="ml-2 text-gray-800 block text-xs">
              I resell product that i buy
            </label>
          </div>
          <div className="flex items-center my-2">
            <input id="i-import" type="checkbox" className="block" />
            <label for="i-import" className="ml-2 text-gray-800 block text-xs">
              I import them
            </label>
          </div>
        </div>
        <div className="flex md:justify-start justify-between py-2 border border-transparent border-b-gray-300">
          <div className="shop prodct category mb-2">
            <label
              for="product-type"
              class="block text-xs font-semibold text-gray-800 mb-2 "
            >
              What is your annual turnover
            </label>
            <select
              id="product-type"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm md:w-48 w-full outline-none block p-1 "
            >
              <option selected>Select an option</option>
              <option value="US">groccery</option>
              <option value="CA">Jewellery</option>
              <option value="FR">Sports products</option>
              <option value="DE">Germany</option>
            </select>
          </div>
          <div className="shop prodct category mb-2 md:ml-8">
            <label
              for="product-type"
              class="block text-xs font-semibold text-gray-800 mb-2 "
            >
              What is your annual turnover
            </label>
            <select
              id="product-type"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm md:w-48 w-full outline-none block p-1 "
            >
              <option selected>Select an option</option>
              <option value="US">groccery</option>
              <option value="CA">Jewellery</option>
              <option value="FR">Sports products</option>
              <option value="DE">Germany</option>
            </select>
          </div>
        </div>

        <div className="w-full mt-4 mb-4">
          <button
            onClick={onNext}
            className=" text-white bg-amber-500 hover:bg-amber-500/90  focus:outline-none font-medium rounded-sm text-sm md:w-56 w-full  px-5 py-2 text-center "
          >
            Next
          </button>
        </div>
      </div>

      <div className="FAQ md:flex-grow ">
        <div className="w-full h-full  py-3 px-3">
          <h1 className="text-lg font-bold text-amber-400 mb-4">FAQ</h1>
          <h1 className="px-2 text-blue-400 font-medium text-xs py-2 border border-transparent border-b-gray-300">
            <button className="text-left">
              {" "}
              Can i select multiple categories ?
            </button>
          </h1>
          <h1 className="px-2 text-blue-400 font-medium text-xs py-2 border border-transparent border-b-gray-300">
            <button className="text-left">
              {" "}
              My category is not listed here ,what should i do ?
            </button>
          </h1>
          <h1 className="px-2 text-blue-400 font-medium text-xs py-2 border border-transparent border-b-gray-300">
            <button className="text-left">
              {" "}
              Which website link should i enter ?
            </button>
          </h1>
        </div>
      </div>
    </div>
  );
};

export default SellerInterview;
